import { Injectable } from '@angular/core';
import { CommonUtil, MessageService, TablePage } from '@serengeti/serengeti-common';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TaskScheduleVariableService {
	endPoint: string;

	constructor(private messageService: MessageService) {
		this.endPoint = CommonUtil.buildEndPoint(environment.serviceSchedulerEndPoint, 'task/variable');
	}

	search(
		filter = '',
		sortItem = 'name', sortOrder = 'asc',
		pageNumber = 1, pageSize = 10): Observable<TablePage> {

		const variableUrl = CommonUtil.buildEndPoint(this.endPoint, '/');

		return this.messageService.query(variableUrl, new HttpParams()
			.set('keyword', filter)
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('pageNumber', pageNumber.toString())
			.set('pageSize', pageSize.toString())
		);
	}

	get(id: string): Observable<any> {
		const variableUrl = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

		return this.messageService.query(variableUrl);
	}

	checkValidityForDelete(id: string): Observable<any> {
		const variableUrl = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/validToBeDeleted');

		return this.messageService.query(variableUrl, null, null, null, true);
	}

	save(variable: any, id?: string) {
		let variableUrl = CommonUtil.buildEndPoint(this.endPoint, '/');

		if (id) {
			variableUrl += id + '/';
			return this.messageService.put(variableUrl, variable);
		} else {
			return this.messageService.post(variableUrl, variable);
		}
	}

	delete(id: string) {
		let variableUrl = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

		return this.messageService.delete(variableUrl);
	}

}
